export default {
  "boardOperations": "Operazioni del Consiglio",
  "manageDailyAssignmentsWorkflowAndCompletionStatus": "Gestisci gli incarichi giornalieri, il flusso di lavoro e lo stato di completamento.",
  "generateBoard": "Scheda di generazione",
  "newTask": "Nuovo compito",
  "myTasks": "I miei compiti",
  "staffProfileUnavailable": "(profilo di posta non disponibile)",
  "boardNotGeneratedYet": "Consiglio non ancora generato",
  "loading": "Caricamento…",
  "noWorkOrders": "Nessun ordine di lavoro.",
  "staffWorkload": "Carico di lavoro personale",
  "noStaffAssignmentsYet": "Non ci sono ancora incarichi per il personale.",
  "selectedRoute": "Itinerario selezionato",
  "selectAStaffMemberToReorderTheirRoute": "Selezionare un membro del personale per riordinare il loro percorso.",
  "roomStatus": "Stato della camera",
  "allOccupancy": "Tutti gli occupanti",
  "vacant": "Vacante",
  "occupied": "Occupazione",
  "reserved": "Riservato",
  "outOfOrder": "Fuori ordinazione",
  "outOfService": "Fuori servizio",
  "housekeeping": "Pulizia delle camere",
  "allHousekeeping": "Tutte le pulizie",
  "ready": "Pronto",
  "needsCleaning": "Bisogno di pulizia",
  "inProgress": "In corso",
  "inspectionPending": "Ispezione in sospeso",
  "blocked": "Bloccato",
  "allRoomsCurrentlyReady": "Tutte le camere sono attualmente pronte.",
  "housekeepingStaff": "Personale di pulizia",
  "manageTheStaffRosterAvailableForHousekeepingTaskAssignment": "Gestire il roster del personale disponibile per l'assegnazione delle mansioni di pulizia.",
  "searchHousekeepingStaff": "Ricerca personale di pulizia",
  "addStaff": "Aggiungere il personale",
  "staff": "Personale",
  "active": "Attivo",
  "inactive": "Inattivo",
  "edit": "Modifica",
  "deactivate": "Disattivare",
  "reactivate": "Riattivare",
  "noHousekeepingStaffRosterEntriesYet": "Non c'e' ancora nessuna voce per il personale delle pulizie.",
  "addHousekeepingStaff": "Aggiunga il personale di pulizia",
  "selectFromClubStaffAndAddToTheHousekeepingRoster": "Selezionare dal personale del club e aggiungere al roster di pulizia.",
  "searchStaff": "Ricerca personale",
  "noMatchingStaff": "Non c'e' personale corrispondente.",
  "shiftPreference": "Preferenze di spostamento",
  "any": "QUALSIASI",
  "am": "AMORE",
  "pm": "PM",
  "notes": "Note",
  "cancel": "Annulla",
  "editHousekeepingStaff": "Modifica Personale di pulizia",
  "updateHousekeepingSpecificRosterSettings": "Aggiornare le impostazioni di roster specifiche per le pulizie.",
  "displayOrder": "Ordine di visualizzazione",
  "save": "Salva",
  "newWorkOrder": "Nuovo ordine di lavoro",
  "createAnAdHocOrPublicAreaTaskForTheBoard": "Creare un compito ad hoc o area pubblica per il consiglio.",
  "selectType": "Selezionare il tipo",
  "roomCode": "Codice camera",
  "eG1204": "es. 1204",
  "selectPriority": "Selezionare la priorità",
  "high": "Alto",
  "medium": "Medio",
  "low": "Basso",
  "estimatedMinutes": "minuti stimati",
  "dueAt": "Due.",
  "createTask": "Creare attività",
  "assignStaff": "Personale delle assegnazioni",
  "start": "Inizio",
  "block": "Blocca",
  "complete": "Completo",
  "inspect": "Indagine",
  "clear": "Cancella",
  "up": "Su.",
  "down": "Giù",
  "unassigned": "Non assegnato",
  "assigned": "Assegnato",
  "needsInspection": "Necessità di ispezione",
  "done": "Fine",
  "closed": "Chiuso",
  "adHoc": "Annuncio Hoc",
  "publicArea": "Spazio pubblico",
  "deepClean": "Pulisci profondamente",
  "maintenance": "Manutenzione",
  "inspection": "Ispezione",
  "checkout": "Pagamento",
  "stayover": "Soggiorno in corso",
  "room": "Camera",
  "nA": "N/A",
  "invalid": "Non valido",
  "addABlockingNoteOptional": "Aggiungi una nota di blocco (opzionale):",
  "didTheRoomPassInspection": "L'ispezione del passaggio della stanza?",
  "inspectionNotesOptional": "Note di ispezione (facoltativo):",
  "editTask": "Modifica delle attività",
  "newHousekeepingTask": "Nuovo compito di pulizia",
  "roomNumber": "Camera {number}",
  "assignedStaff": "Personale incaricato",
  "scheduledTime": "Tempo programmato",
  "serviceType": "Tipo di servizio",
  "dailyCleaning": "Pulizia giornaliera",
  "checkoutCleaning": "Pulizia del check-out",
  "deepCleaning": "Pulizia profonda",
  "pending": "In attesa",
  "completed": "Completato",
  "onHold": "Aspetta.",
  "urgent": "Urgente",
  "updateTask": "Attività di aggiornamento",
  "housekeepingBoard": "Consiglio di amministrazione",
  "visualBoardOfRoomStatusesAndCleaningTasks": "Scheda visiva di stato delle camere e compiti di pulizia.",
  "noHousekeepingTasksFound": "Nessun compito di pulizia trovato.",
  "createFirstTask": "Creare la prima attività",
  "searchingStaff": "Personale di ricerca...",
  "typeAtLeast2CharactersToSearch": "Digita almeno 2 caratteri per cercare.",
  "noResultsFound": "Nessun risultato trovato.",
  "boardName": "Consiglio: {name}",
  "dueDate": "A causa: {date}",
  "assignedName": "Assegnato: {name}",
  "shiftShiftOrderOrder": "Maiusc: {shift} • Ordine: {order}",
  "countMinutesMin": "{count} • {minutes} min",
  "unableToCompleteThisHousekeepingRequestPleaseTryAgain": "Non è possibile completare questa richiesta di pulizia. Si prega di riprovare.",
  "staffSearchIsUnavailablePleaseTryAgain": "Ricerca personale non è disponibile. Si prega di riprovare.",
  "errors": {
    "invalid_request": "Richiesta di pulizia non valida.",
    "room_not_found": "Camera non trovata.",
    "not_found": "Il registro delle pulizie non e' stato trovato.",
    "invalid_status": "Lo stato non valido.",
    "invalid_status_transition": "Questa transizione di stato non è consentito.",
    "staff_not_found": "Membro del personale non trovato.",
    "board_required": "Generare una scheda prima di assegnare il lavoro.",
    "invalid_shift_preference": "Preferenze di turno non valide.",
    "invalid_display_order": "Inserire un ordine di visualizzazione valido.",
    "no_updates": "Nessun cambiamento da salvare."
  },
  "enums": {
    "status": {
      "queued": "Non assegnato",
      "assigned": "Assegnato",
      "in_progress": "In corso",
      "blocked": "Bloccato",
      "needs_inspection": "Necessità di ispezione",
      "done": "Fine",
      "closed": "Chiuso",
      "pending": "In attesa",
      "completed": "Completato",
      "on_hold": "Aspetta.",
      "ready": "Pronto",
      "needs_cleaning": "Bisogno di pulizia",
      "inspected": "Ispezione in sospeso",
      "cancelled": "Annullato"
    },
    "type": {
      "ad_hoc": "Annuncio Hoc",
      "public_area": "Spazio pubblico",
      "deep_clean": "Pulisci profondamente",
      "maintenance": "Manutenzione",
      "inspection": "Ispezione",
      "checkout": "Pagamento",
      "stayover": "Soggiorno in corso",
      "daily_cleaning": "Pulizia giornaliera",
      "checkout_cleaning": "Pulizia del check-out",
      "deep_cleaning": "Pulizia profonda",
      "checkout_clean": "Checkout pulito",
      "stayover_clean": "Soggiorni puliti",
      "arrival_refresh": "Aggiornamento di arrivo"
    },
    "priority": {
      "high": "Alto",
      "medium": "Medio",
      "low": "Basso",
      "urgent": "Urgente"
    },
    "occupancy": {
      "vacant": "Vacante",
      "occupied": "Occupazione",
      "reserved": "Riservato",
      "out_of_order": "Fuori ordinazione",
      "out_of_service": "Fuori servizio"
    },
    "shift": {
      "ANY": "Qualsiasi",
      "AM": "AMORE",
      "PM": "PM"
    }
  },
  "status": "Stato",
  "type": "Tipo",
  "priority": "Priorità",
  "occupancy": "Occupazione",
  "shift": "Maiusc.",
  "boardDate": "Data del Consiglio",
  "requiredField": "Completare questo campo richiesto.",
  "generatedBoardName": "Consiglio di pulizia {date} {shift}"
};
